import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ProductFacetValueDto } from './ProductFacetValueDto'
import { ProductFacetKind } from './Enums'
/**
* Class ProductFacetDto
*  Один фасет (ось фильтра) в сайдбаре
*/
export class ProductFacetDto extends ActiveModel {

  /**
  * attributeId
  * Идентификатор атрибута<br>  */
  @ActiveField(0)
  attributeId: number = 0


/**
  * displayName
  * Отображаемое имя атрибута<br>
  */
  @ActiveField('')
  displayName: string = ''


/**
  * systemName
  * Системное имя атрибута, если задано<br>
  */
  @ActiveField()
  systemName?: null | string


  /**
  * kind
  * словарь значений публикуется под именем `Web.Api.Showcases.Controllers.Products.Models.ProductFacetKind`  *   * Вид фасета<br>  *   * - `enum` Перечисление  *   * Перечисление (справочник или строка)  * - `bool` Логический  *   * Логический (Да/Нет)  * - `range` Диапазон  *   * Числовой диапазон  *   */
  @ActiveField(ProductFacetKind.ENUM)
  kind: ProductFacetKind = ProductFacetKind.ENUM


/**
  * @property values
  * Значения дискретного фасета; для диапазона не заполняется<br>  */
  @ActiveField({
    factory: [ProductFacetValueDto, () => undefined]
  })
  values?: null | Array<ProductFacetValueDto>


  /**
  * hasMore
  * В universe больше значений, чем отдано<br>  */
  @ActiveField()
  hasMore?: null | boolean


  /**
  * min
  * Минимум по полному срезу; оба конца null, если карточек нет<br>  */
  @ActiveField()
  min?: null | number


  /**
  * max
  * Максимум по полному срезу; оба конца null, если карточек нет<br>  */
  @ActiveField()
  max?: null | number


/**
  * selectedMin
  * Эхо `Filter.Attrs[].min`
  */
  @ActiveField()
  selectedMin?: null | string


/**
  * selectedMax
  * Эхо `Filter.Attrs[].max`
  */
  @ActiveField()
  selectedMax?: null | string
}
